import React, { useState } from "react";
import axios from "axios";
import routes from "../../app/routes";
import { Button, Modal } from "react-bootstrap";
import Form from "./Form";

//workType: AdminChangeMember, AdminChangeCoach, CoachingPlanChangeCoach, CoachChangeCoach
export default function CreateButton({
  buttonName,
  workType,
  className,
  coachName,
  programName,
  coachingPlanId,
  actionPlanId,
  updateCollection,
}) {
  const [show, setShow] = useState(false);

  const closeForm = () => setShow(false);
  const openForm = () => setShow(true);

  let modalHeader = "Coach Change Request";

  return (
    <>
      <Button className={className} onClick={openForm}>
        {buttonName}
      </Button>

      <Modal
        className="student inmodal auto without-overflow"
        show={show}
        onHide={closeForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            closeForm={closeForm}
            workType={workType}
            coachName={coachName}
            programName={programName}
            coachingPlanId={coachingPlanId}
            actionPlanId={actionPlanId}
            updateCollection={updateCollection}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
